import { render, staticRenderFns } from "./alertMessage.vue?vue&type=template&id=109a23a2&scoped=true"
import script from "./alertMessage.vue?vue&type=script&lang=js"
export * from "./alertMessage.vue?vue&type=script&lang=js"
import style0 from "./alertMessage.vue?vue&type=style&index=0&id=109a23a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a23a2",
  null
  
)

export default component.exports